module.exports = __webpack_public_path__ + "img/Lokale_Belieferung_Banner_Startseite_unten.7995a2e1.webp";